<template>
	<WizardInputFieldLayout title="Command icon" description="Appears next to the command text">
		<template #input>
			<IconStyleEditor :btnSettings.sync="localValue" :allowColor="false" />
		</template>
	</WizardInputFieldLayout>
</template>

<script>
import IconStyleEditor from '@/components/BlockEditor/ButtonEditorDrawer/tabs/IconStyleEditor.vue';
import WizardInputFieldLayout from '@/components/common/WizardInputFieldLayout.vue';
import VModelMixin from '@/mixins/VModelMixin';

export default {
	name: 'ToolIconInputField',
	mixins: [VModelMixin],
	components: { IconStyleEditor, WizardInputFieldLayout },
};
</script>

<style lang="scss" scoped></style>
